import { ComponentSettings, FieldTypes } from "../settings/settings";

const field = {
  designType: {
    type: FieldTypes.value,
    text: {
      de: "Produkttyp",
      en: "Product Type",
      nl: "Product Type"
    }
  },
  responsible: {
    type: FieldTypes.value,
    text: {
      de: "Verantwortlicher",
      en: "Responsible",
      nl: "Verantwoordelijke"
    }
  }
};

const settings = {
  permission: {},
  text: {
    productTypeResponsibles: {
      de: "Produkttyp Verantwortliche",
      en: "Product Type Responsibles",
      nl: "Product Type Responsibles"
    }
  },
  url: {},
  field,
  list: {},
  additionalInfo: {}
};

export const productTypeResponsibles: ComponentSettings<typeof settings> =
  settings;
